import { defineNuxtPlugin, useNuxtApp } from "#app";
import { watch } from "vue";
import { useFeatureFlags } from "../stores/featureFlags.js";
export default defineNuxtPlugin({
  name: "rialtic-feature-flags",
  dependsOn: ["001-auth0"],
  async setup() {
    const nuxtApp = useNuxtApp();
    const $auth0Ready = nuxtApp.$auth0Ready;
    const $auth0 = nuxtApp.$auth0;
    if ($auth0Ready) await $auth0Ready();
    const { initialize } = useFeatureFlags();
    const tryInitialize = async () => {
      try {
        await initialize();
      } catch (error) {
        if (false) {
          console.warn("Feature flags initialization failed:", error);
        }
      }
    };
    if (!$auth0?.().isAuthenticated.value) {
      watch(
        () => $auth0?.().isAuthenticated.value ?? false,
        async (authed) => {
          if (authed) await tryInitialize();
        },
        { once: true }
      );
      return;
    }
    await tryInitialize();
  }
});
